import { useEffect } from 'react';

import { signalFinishedLoadingToMobiles } from 'flow/actions/app-actions';
import Page from 'flow/components/Setting/Page';
import Loading from 'flow/components/ui-components/Loading';
import RouteLink from 'flow/components/ui-components/RouteLink';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import useSettingsNavigation from 'flow/hooks/useSettingsNavigation';
import { selectIsSinglePaneMode } from 'flow/selectors/app-selectors';
import { routes } from 'flow/types/routes';

import useTranscriptionSettingsReady from './useTranscriptionSettingsReady';

const SettingsTranscriptions = () => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const isSinglePaneMode = useAppSelector(selectIsSinglePaneMode);
    const { goToSettings } = useSettingsNavigation();
    const ready = useTranscriptionSettingsReady();

    // Signal to mobile clients that the page has finished loading.
    useEffect(() => {
        if (ready) {
            dispatch(signalFinishedLoadingToMobiles());
        }
    }, [dispatch, ready]);

    if (!ready) {
        return <Loading />;
    }

    return (
        <Page
            childrenClassName="mx-auto w-full max-w-screen-sm p-3"
            header="settings.transcriptions"
            onClickBack={isSinglePaneMode ? goToSettings : undefined}
        >
            <RouteLink to={routes['settings.transcriptions.quota']}>
                {i18next.t('settings.usage.usage')}
            </RouteLink>
            <RouteLink to={routes['settings.transcriptions.call-summary']}>
                {i18next.t('settings.transcriptions.call_summary')}
            </RouteLink>
        </Page>
    );
};

export default SettingsTranscriptions;
